export const SET_ORDERTYPE_PRODUCT = 'SET_ORDERTYPE_PRODUCT'
